// Admin inbox for sponsorship / collaboration requests (§4).

import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, RefreshCw } from "lucide-react";

const STATUSES = ["Pending", "Contacted", "Approved", "Rejected"];

const STATUS_COLORS = {
  Pending:   "#B89C3A",
  Contacted: "#8FD1E5",
  Approved:  "#6E8B3D",
  Rejected:  "#E33333",
};

export default function SponsorshipInbox() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = async () => {
    setLoading(true);
    try {
      const r = await api.sponsorshipList();
      setRows(r.requests || []);
    } catch (err) {
      toast.error("Errore nel caricamento");
    } finally { setLoading(false); }
  };
  useEffect(() => { refresh(); }, []);

  const setStatus = async (id, status) => {
    try {
      await api.sponsorshipSetStatus(id, status);
      setRows(prev => prev.map(r => r.id === id ? { ...r, status } : r));
      toast.success(`Stato: ${status}`);
    } catch (err) { toast.error("Aggiornamento fallito"); }
  };

  return (
    <div className="space-y-3" data-testid="gm-sponsorship-inbox">
      <div className="flex items-center gap-2">
        <div>
          <div className="font-heading text-sm tracking-[0.3em] uppercase text-[#E5C34A] flex items-center gap-2">
            <Mail className="w-4 h-4" /> Richieste sponsor
          </div>
          <div className="font-mono text-[9px] tracking-widest uppercase text-[#666]">{rows.length} richieste totali</div>
        </div>
        <button data-testid="sponsor-refresh" onClick={refresh} disabled={loading}
          className="ml-auto px-3 py-2 border border-[#B89C3A] text-[#E5C34A] font-heading text-[10px] tracking-widest uppercase flex items-center gap-1.5 disabled:opacity-50">
          <RefreshCw className={`w-3 h-3 ${loading ? "animate-spin" : ""}`} /> Ricarica
        </button>
      </div>

      {rows.length === 0 && (
        <div className="panel p-6 text-center text-xs italic text-[#666]">Nessuna richiesta.</div>
      )}
      <div className="space-y-2">
        {rows.map(r => (
          <div key={r.id} data-testid={`sponsor-row-${r.id}`} className="panel p-3">
            <div className="flex flex-wrap items-center gap-2 mb-1">
              <span className="font-heading text-[12px] tracking-widest uppercase text-[#E5C34A]">{r.name}</span>
              <span className="font-mono text-[10px] text-[#B89C3A]">· {r.kind}</span>
              <span className="ml-auto px-2 py-0.5 font-mono text-[9px] tracking-widest uppercase border"
                style={{ color: STATUS_COLORS[r.status] || "#666", borderColor: STATUS_COLORS[r.status] || "#333" }}>
                {r.status || "Pending"}
              </span>
            </div>
            <div className="font-mono text-[10px] text-[#B0ADA5]">{r.contact}</div>
            <div className="text-[12px] text-[#E2DFD8] mt-2 whitespace-pre-wrap">{r.message}</div>
            <div className="flex gap-1 mt-2 pt-2 border-t border-[#262626]">
              {STATUSES.map(st => (
                <button key={st} type="button"
                  data-testid={`sponsor-${r.id}-set-${st.toLowerCase()}`}
                  onClick={() => setStatus(r.id, st)}
                  disabled={r.status === st}
                  className={`px-2 py-1 border font-mono text-[9px] uppercase tracking-widest ${
                    r.status === st
                      ? "border-[color:var(--c)] text-[color:var(--c)] bg-[color:var(--c)]/10"
                      : "border-[#262626] text-[#8c8c8c] hover:text-[#B0ADA5]"
                  }`}
                  style={{ "--c": STATUS_COLORS[st] || "#666" }}>
                  {st}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
